import React, {Component, lazy, Suspense} from 'react';

import {AppContext} from '../../AppModule/Context';
import {withWidgetContext} from '../widgetComponent/widgetContextProvider';

import NotificationComponent from '../common/genericComponents/notificationComponent';
import SuspenseLoader from '../common/genericComponents/suspenseLoader/suspenseLoader';

import audioFileService from '../../services/audioFileService';
import AnalyticsService from '../../services/analyticsService';
import cnameInstanceService from '../../services/restServices/cnameInstanceService';
import {ListeningRoomService} from '../../services/websocketService';
import OpenTokService from '../../services/opentokService';
// import PaypalPaymentService from '../../services/paypalPaymentService';
import SessionInstanceService from '../../services/restServices/sessionInstanceService';
import SmsMessageService from '../../services/restServices/smsMessageService';
import utilsService from '../../services/utilsService';

import STRINGS from '../../config/strings';
import VIDABOO_CONSTANTS from '../../config/consts';

import './callInitiatorComponent.css';

const C2cPaymentComponent = lazy(
  () => import('../paymentRequestComponent/c2cPaymentComponent'),
);
const OtVideo = lazy(() => import('./otVideo'));
// import c2cStripeTransactionsService from '../../services/restServices/c2cStripeTransactionsService';

let $scope = {};

class CallInitiator extends Component {
  constructor(props) {
    super();
    this.callAudio = VIDABOO_CONSTANTS.NATIVE_APP
      ? null
      : audioFileService.playOrGetAudioFile(
          VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CALL_AUDIO,
          true,
          {volume: 0.1},
        );
    this.state = {startCallOnInit: props.startCallOnInit};
    this.state.popupButtons = [];
    this.state.popupFunction = [];
    this.state.peerCameraState = true;
    this.state.callRecordingActive = false;
    this.state.audioPaused = true;
    this.state.showRecordingPopup = false;
    this.state.totalStreamsCount = 0;
    this.state.maxAmountOfVideoStreamsAchieved = false;
  }
  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom();
    window.removeEventListener('message', this.paymentListenerFunction); // just in case we had another one
    clearInterval(this.waitForChildWindowCloseInterval);
    clearInterval(this.soundInterval);
    clearTimeout(this.infoCollectorTimer);
    this.cancelListenerToWindowChangeLocation();
  };
  componentDidMount = () => {
    this.fncObj = this.props.fncObj;
    this.fldObj = this.props.fldObj;
    this.paypalPayKey = '1';
    this.OTSessionData = {};
    this.otVideoFncObj = {};

    this.popupFunction = {};
    this.fldObjToOtVideo = {};
    this.fldObjToOtVideo.mentor = this.props.mentor;
    this.fldObjToOtVideo.currentUser = this.props.currentUser;

    this.fldObjToOtVideo.defaultSession = this.props.defaultSession;

    this.fncObj.startCall = this.startCall;

    this.infoCollectorTimer = null;
    this.doWhenWSConnectedAndMentor();
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.props.widgetContext.privateChatRoomDto?.privateChatRoomId &&
      this.props.widgetContext.privateChatRoomDto.privateChatRoomId !==
        prevProps.widgetContext.privateChatRoomDto?.privateChatRoomId
    ) {
      //private chat room got created -> so set the default 1 X 1 chatroom id as selectedChatRoomId
      this.props.widgetContext.setSelectedChatRoomId(
        this.props.mentor.mentorDto.mentorOwnerId,
      );
    }
  };

  // getPaymentStatus = () => {
  //   PaypalPaymentService.getPaymentDetails(
  //     this.paypalPayKey,
  //     this.moneyTransactionId,
  //     (response) => {
  //       var status = response.status;
  //       var messageToSend = {
  //         SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.PAYMENT_STATUS,
  //         status: status,
  //         apiKey: this.paypalPayKey,
  //       };
  //       if (
  //         response.status ===
  //         VIDABOO_CONSTANTS.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS
  //       ) {
  //         //send to client that every thing fine.
  //         messageToSend.status = status;
  //       } else {
  //         //send to client that somethng wrong with payment
  //         // console.debug('send to client that somethng wrong with payment');
  //         messageToSend.status = status;
  //       }
  //       ListeningRoomService.publishToListeningRoom(
  //         messageToSend,
  //         this.props.currentUser.userId,
  //         this.props.mentor.mentorDto.userId,
  //         VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
  //       );
  //       //PRService.emitMessage(messageToSend);
  //     },
  //     () => {
  //       //send to client that somethng wrong with payment
  //       var messageToSend = {
  //         SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.PAYMENT_STATUS,
  //         status: 'FAIL',
  //       };
  //       ListeningRoomService.publishToListeningRoom(
  //         messageToSend,
  //         this.props.currentUser.userId,
  //         this.props.mentor.mentorDto.userId,
  //         VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
  //       );
  //       // PRService.emitMessage('');
  //     },
  //   );
  // };

  doWhenMentorAcceptPayment = () => {
    this.paymentInProcess = true;
    this.setState({shouldStartPaymentFlow: true});
    // this.setState({
    //   showNotificationPopup: true,
    //   notificationText:
    //     Your peer is ready. Please start payment, // STRINGS.POPUP_MESSAGES.CALL_APP_MESSAGES.MENTOR_ACCEPTED_PAID_CALL,
    //   notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.DARK,
    //   popupAcceptBtnText: "Pay now",
    //   popupRejectBtnFunc: null,
    //   popupRejectBtnText: null,
    //   popupCloseBtnFunc: null,
    //   popupCloseBtnText: null,

    //   popupAcceptBtnFunc: this.openPaymentRequestPopup,
    // });
  };
  paymentListenerFunction = (ev) => {
    if (ev.data.message === 'et-deliverResult') {
      // console.debug("received message with payment ID");
      ev.source.close();
    }
  };
  // openPaymentRequestPopup = () => {
  //   //var url = 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_ap-payment&paykey=' + this.paypalPayKey;
  //   window.removeEventListener('message', this.paymentListenerFunction); // just in case we had another one

  //   var url = VIDABOO_CONSTANTS.PAYPAL_WINDOW_URL + this.paypalPayKey;
  //   this.childWindow = window.open(
  //     url,
  //     /*'_blank'*/ 'C-Sharpcorner',
  //     'width=900,height=600',
  //   );
  //   window.addEventListener('message', this.paymentListenerFunction);
  //   this.waitForChildWindowCloseInterval = setInterval(() => {
  //     if (this.childWindow.closed) {
  //       window.removeEventListener('message', this.paymentListenerFunction); // just in case we had another one
  //       clearInterval(this.waitForChildWindowCloseInterval);
  //       this.setState({showNotificationPopup: false}); // closing popup that started payment flow
  //       this.getPaymentStatus();
  //       this.paymentInProcess = false;
  //     }
  //   }, 500);
  // };

  checkMentorAvailability = () => {
    if (
      this.props.mentorStatus ===
        VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE ||
      this.props.mentorStatus === VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY ||
      this.props.mentor.standbyEnabled
    ) {
      return true;
    } else {
      return false;
    }
  };
  playSound = () => {
    //audio.play();
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      this.setState({
        audioPaused: false,
      });
    } else {
      const promise = this.callAudio.play();

      if (promise !== undefined) {
        promise
          .then(() => {
            // Autoplay started!
          })
          .catch(() => {
            // Show something in the UI that the video is muted
            // this.callAudio.play();
          });
      }
    }
  };
  ring = () => {
    if (!this.soundInterval) {
      this.soundInterval = setInterval(() => {
        this.playSound();
      }, 1100);
    }
  };
  doWhenWSConnectedAndMentor = () => {
    // console.debug('websocked is called');
    // const mentorUserId = this.props.mentor.mentorDto.mentorOwnerId;

    if (this.state.startCallOnInit === true) {
      // this.mentorStatus = data.content.availabilityState.toLowerCase();
      this.setState({startCallOnInit: false}); // we want this to happen only once
      // analytics event was sent in the initiating window.
      this.startCall(this.props.defaultSession, false, false);
    }

    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        const messageType = data.messageType;
        if (
          messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL &&
          (data.senderUserId === this.props.mentor.mentorDto.mentorOwnerId ||
            data.senderUserId === this.props.currentUser.userId ||
            data.senderUserId === 'server')
        ) {
          // we want to make sure that the message was sent by the mentor or the user and not someone else.

          const messageSubType = data.content.SubType;
          const content = data.content;
          switch (messageSubType) {
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.RESPONSE_TO_CALL_REQUEST:
              if (!this.state.callRequestStartedNonResponded) return;
              clearTimeout(this.infoCollectorTimer);
              this.setState({callRequestStartedNonResponded: false});
              if (!this.winPopup) {
                // this.showInfoCollector = false;
                if (
                  content.response ===
                  VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.ACCEPT
                ) {
                  this.stopRing();
                  this.sendGA(
                    VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET
                      .CALL_STARTED_CLIENT,
                    this.props.mentor.mentorDto.profileName,
                  );
                  this.dispatchConsoltoEvents(
                    VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET
                      .CALL_STARTED_CLIENT,
                  );
                  this.joinSessionInstance(data.content, false);
                  this.otVideoFncObj.doWhenAccept();
                }
                if (
                  content.response ===
                  VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.REJECT
                ) {
                  this.props?.widgetContext?.setCallReqId(null);
                  this.props?.widgetContext?.setEngagerReqId(null);

                  this.resetCallInitiator();
                  this.setState({
                    showNotificationPopup: true,
                    notificationText:
                      this.context.languageSet.VIDEO_CALL_CAT
                        .REJECTED_CALL_MESSAGE,
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
                    popupAcceptBtnFunc: null,
                    popupAcceptBtnText: null,
                    popupRejectBtnFunc: null,
                    popupRejectBtnText: null,
                    popupCloseBtnFunc: null,
                    popupCloseBtnText: null,
                  });
                  this.otVideoFncObj.doWhenReject();
                }
                if (
                  content.response ===
                  VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.ACCEPTPAYMENT
                ) {
                  this.stopRing();
                  this.doWhenMentorAcceptPayment();
                }
              }
              return;
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.PEER_DISCONNECT:
              // only if we didn't start a callInPopup
              // console.debug(
              //   'PEER_DISCONNECT: ',
              //   this.context.callState,
              //   ' ',
              //   data.content.peerUserId,
              // );
              if (
                // if disconnect message arrives during call, video controller will handle it. While in establishment, handle it here.
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_REQUESTED ||
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.JOIN_CALL_REQUESTED ||
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_ACCEPTED ||
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.SENDING_VIDEO_TO_PEER
              ) {
                if (
                  // other joining user can disconnect and we should ignore it.
                  data.content.peerUserId ===
                  this.props.mentor.mentorDto.mentorOwnerId
                ) {
                  this.clientSessionInstanceEnd();
                  this.hangUp();
                  this.otVideoFncObj.doWhenReject();
                  this.paymentInProcess = false;
                  // }
                  // this.showInfoCollector = true;
                  this.fncObj.changeIframeSize(
                    VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
                    'callInitiator',
                  );
                  this.context.setCallState(
                    VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT,
                  );

                  this.stopRing();
                  this.setState({
                    showNotificationPopup: true,
                    notificationText:
                      this.context.languageSet.VIDEO_CALL_CAT
                        .PEER_CONNECTION_CLOSED_MESSAGE,
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
                    popupAcceptBtnFunc: null,
                    popupAcceptBtnText: null,
                    popupRejectBtnFunc: null,
                    popupRejectBtnText: null,
                    popupCloseBtnFunc: null,
                    popupCloseBtnText: null,
                  });
                }
                // if (this.paymentInProcess) {
                //peer could be disconnecting while we started the payment process.
              }
              return;
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.HANGUP:
              if (
                // if hangup message arrives during call, video controller will handle it. Otherwise, handle it here.
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_REQUESTED ||
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.JOIN_CALL_REQUESTED ||
                this.context.callState ===
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_ACCEPTED
              ) {
                this.resetCallInitiator();
                this.context.setCallState(
                  VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT,
                );
                this.clientSessionInstanceEnd();
                this.otVideoFncObj.doWhenReject();
                if (!this.winPopup) {
                  this.setState({
                    showNotificationPopup: true,
                    notificationText:
                      this.context.languageSet.VIDEO_CALL_CAT
                        .PEER_CONNECTION_CLOSED_MESSAGE,
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
                    popupAcceptBtnFunc: null,
                    popupAcceptBtnText: null,
                    popupRejectBtnFunc: null,
                    popupRejectBtnText: null,
                    popupCloseBtnFunc: null,
                    popupCloseBtnText: null,
                    showRecordingPopup: false,
                  });
                }
              }

              return;
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.CAMERA_STATE:
              this.setState({peerCameraState: data.content.cameraState});

              return;
            case VIDABOO_CONSTANTS.CALL_SUBTYPES
              .REQUEST_TO_RESEND_CALL_REQUEST: {
              const callRequestData = this.createCallRequestData();
              callRequestData.resendCallRequest = true; // required for websocket. DO NOT REMOVE
              callRequestData.resendCallRequestId =
                this.props.widgetContext?.callReqId; // required for websocket. DO NOT REMOVE
              // console.debug('Message Data to be sent: ', callRequestData);

              if (
                !this.props.widgetContext?.callReqId ||
                this.props.widgetContext?.callReqId !== data.content.callReqId
              ) {
                return; // in case this request to resend the callRequest was eliminated or from another device - return.
              }
              ListeningRoomService.publishToListeningRoom(
                callRequestData,
                this.props.currentUser.userId,
                this.props.mentor.mentorDto.mentorOwnerId,
                VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
              );
              return;
            }
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.CALL_RECORDING_STARTED:
              this.handleCallRecordingState(true);

              return;
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.CALL_RECORDING_ENDED:
              this.handleCallRecordingState(false);

              return;
            case VIDABOO_CONSTANTS.CALL_SUBTYPES.RESPONSE_TO_JOIN_CALL_REQUEST:
              if (!this.state.callRequestStartedNonResponded) return;
              clearTimeout(this.infoCollectorTimer);
              this.setState({callRequestStartedNonResponded: false});
              this.stopRing();
              if (
                this.context.callState ===
                VIDABOO_CONSTANTS.VIDEO_CALL_STATE.JOIN_CALL_REQUESTED
              ) {
                if (
                  content.response ===
                  VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.ACCEPT
                ) {
                  const joinExistingMeetingOtSessionData =
                    content.OTSessionData;
                  this.tokBoxInit(joinExistingMeetingOtSessionData);
                  this.joinSessionInstance(data.content, true);
                } else if (
                  content.response ===
                  VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.REJECT
                ) {
                  this.context.setCallState(
                    VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT,
                  );
                  this.setState({
                    showNotificationPopup: true,
                    notificationText:
                      this.context.languageSet.VIDEO_CALL_CAT
                        .REJECTED_CALL_MESSAGE,
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
                    popupAcceptBtnFunc: null,
                    popupAcceptBtnText: null,
                    popupRejectBtnFunc: null,
                    popupRejectBtnText: null,
                    popupCloseBtnFunc: null,
                    popupCloseBtnText: null,
                  });
                }
              }

              return;

            default:
              console.debug('Error 104: received an unknown message');
          }
        } else if (
          messageType ===
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.PRIVATE_CHAT_ROOM &&
          data.senderUserId === this.props.mentor.mentorDto.mentorOwnerId &&
          data.content.SubType ===
            VIDABOO_CONSTANTS.PRIVATE_CHAT_ROOM_SUBTYPES
              .PRIVATE_CHAT_ROOM_INFO_RESPONSE &&
          !data.content.meetingRoomId //TODOGC: if users opens meeting room and clickNTalk page in same browser window, so callInitiator should not do anything if meetingRoomId is present in content
        ) {
          console.debug('Private room (messageFromListeningRoom): ', data);
          delete data.content.SubType;
          this.props.widgetContext.setPrivateChatRoomDto(data.content);
        }
      });
  };
  //////////////////   SESSION INSTANCE HANDLING //////////
  joinSessionInstance = (data, isJoiningSession) => {
    var currentTime = new Date().getTime();
    this.sessionInstanceDto = data.sessionInstanceDto;
    var joinSessionInstanceData = {
      sessionInstanceId: data.sessionInstanceDto.sessionInstanceId,
      clientUserId: this.props.currentUser.userId,
      sessionStartTimeClient: currentTime,
      moneyTransactionId: this.moneyTransactionId,
      isJoiningSession, // in case of joining only.
    };
    SessionInstanceService.clientJoinSessionInstance(
      joinSessionInstanceData,
      (response) => {
        if (!isJoiningSession) this.doWhenClientJoindSessionInstance(response);
      },
    );
  };
  doWhenClientJoindSessionInstance = (/* res */) => {
    //check session instance heartbeat client.
    if (this.streamId)
      this.sessionHeartBeatFunc({
        streamId: this.streamId,
        chatParticipant: {
          objectType: VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.GUEST,
          objectId: this.context.getCurrentUser().userId,
        },
      });
    this.sessionHeartBeatInterVal = setInterval(
      this.sessionHeartBeatFunc,
      VIDABOO_CONSTANTS.SESSION_INSTANCE_HEARTBEAT.Client,
    );
    // console.debug('JoinSessionInstance ', res);
  };
  doWhenStreamCreated = (streamId) => {
    this.streamId = streamId;
  };
  sessionHeartBeatFunc = (metaData = null) => {
    // if (OpenTokService.publisherConnect === true) {
    if (this.sessionInstanceDto) {
      var sessionInstanceHeartBeatData = {
        sessionInstanceId: this.sessionInstanceDto.sessionInstanceId,
        clientUserId: this.props.currentUser.userId,
      };
      SessionInstanceService.clientSessionInstanceHeartBeat(
        sessionInstanceHeartBeatData,
        metaData,
        (/* res */) => {
          // console.debug('client hearbeat - ', res);
        },
        (/* res */) => {
          // alert('error', res);
        },
      );
    }
    // } else {
    //   //end client session instance.
    //   this.clientSessionInstanceEnd();
    //   //alert('offline');
    // }
  };
  clientSessionInstanceEnd = () => {
    clearInterval(this.sessionHeartBeatInterVal);

    if (this.sessionInstanceDto !== undefined) {
      var currentTime = new Date().getTime();
      //var sessionInstanceId = data.sessionInstanceId;
      var endSessionInstanceDto = {
        sessionInstanceId: this.sessionInstanceDto.sessionInstanceId,
        clientUserId: this.props.currentUser.userId,
        sessionEndTimeClient: currentTime,
      };
      SessionInstanceService.clientSessionInstanceEnd(
        endSessionInstanceDto,
        (/* res */) => {
          // console.debug('clientSessionInstanceEnd success result - ', res);
        },
        (res) => {
          console.debug('clientSessionInstanceEnd fail result - ', res);
        },
      );
    }
    this.sessionInstanceDto = undefined;
  };

  getExtension = () => {
    window.open(
      'https://chrome.google.com/webstore/detail/consolto-screen-sharing/nhfjbienalifdeomfpbnofcodgffaghe',
      'Screen Shareing Extension',
    );
    this.popupButtons = [];
    this.popupFunction = {};
    this.setState({showNotificationPopup: false});
  };
  //////////////////   END SESSION INSTANCE HANDLING //////////

  closePopups = () => {
    this.setState({showNotificationPopup: false});
    //if we are within a popup and we got the close Popup, we should close the window.
    //todo: need to add here a check whether we are within a popup.
    if (utilsService.getIsInCallInPopup()) this.fncObj.closeWindow();
  };
  errorCallback = (e) => {
    //   POPUP - need to ask user to enable video and audio;
    console.debug('Video/audio are not enabled !', e);
    $scope.enableVideoPopup = true;
    $scope.popInstructionsImgRef =
      'https://res.cloudinary.com/expertips/image/upload/v1493990027/expertipsPhotos/explanation2.jpg';
    $scope.videoPopInstructions =
      'Video/audio should be enabled. Right click the icon (see below) and allow exper.tips to use the camera';
  };

  startCall = async (
    sessionTemplate,
    forceStartInPopup,
    sendAnalyticsEvent,
    peerClientInfo,
  ) => {
    console.debug(
      'Call starts',
      // 'sessionTemplate',
      // sessionTemplate,
      // 'forceStartInPopup',
      // forceStartInPopup,
      // 'sendAnalyticsEvent',
      // sendAnalyticsEvent,
      'peerClientInfo',
      peerClientInfo,
    );

    this.peerClientInfo = peerClientInfo;

    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      return;
    }
    this.winPopup = null;
    if (
      this.props.mentor.mentorDto.mentorOwnerId ===
      this.props.currentUser.userId
    ) {
      this.setState({showNotificationPopup: true});
      this.popupSeverity = STRINGS.POPUP_SEVERITY.WARNING;
      this.popupTitle = STRINGS.POPUP_MESSAGES.TITLES.OOOPS;
      this.popupMessage =
        this.context.languageSet.VIDEO_CALL_CAT.SELF_CALL_MESSAGE;
      alert('same User!!');
      return;
    }

    const smsMessageDto = {
      senderUserId: 'guest',
      receiverUserId: this.props.mentor.mentorDto.mentorOwnerId,
      smsContent:
        'Hi ' +
        this.props.mentor.firstName +
        ', a client is trying to call you from within your website. Goto app.consolto.com to receive the call', // todo 2570 : fix app.consolto.com
      smsNotificationType:
        VIDABOO_CONSTANTS.NOTIFICATION_TYPES_KEYS.CALL_SMS_NOTIFICATION,
    };
    SmsMessageService.sendSmsMessageToMentorByUserId(smsMessageDto);

    if (!this.checkMentorAvailability()) {
      if (sendAnalyticsEvent)
        this.sendGA(
          'startingCallMentorOffline',
          this.props.mentor.mentorDto.profileName,
        );

      this.fncObj.changeIframeSize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
        'callInitiator',
      );
      this.props.postCallFailFnc();
      return;
    }
    const mentorIsBusy =
      this.props.mentorStatus === VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY;

    if (sendAnalyticsEvent) {
      this.sendGA(
        mentorIsBusy ? 'joinCallMentorBusy' : 'startingCallMentorOnline',
        this.props.mentor.mentorDto.profileName,
      );
    }
    //if the session that we passed from dom is null the default session will be used
    // if (!sessionTemplate) {
    //   this.props.sessions.forEach((sessionTemplateDto) => {
    //     if (sessionTemplateDto.isDefault) {
    //       this.props.defaultSession = sessionTemplateDto;
    //     }
    //   });
    // } else {
    //   this.props.defaultSession = sessionTemplate;
    // }

    if (
      !VIDABOO_CONSTANTS.TEST_ENV &&
      utilsService.getIsInWidget() === true &&
      document.referrer.search(/^https/) < 0
    ) {
      const domainUrl = await cnameInstanceService.getDomainUrlByWidgetId(
        this.props.widgetContext?.widgetDto?.widgetId,
      );
      // on non-http websites, we should pop the ClickNTalk page.
      const popupLocation = `${domainUrl}/expert/${this.props.mentor.mentorDto.profileName}?start=videocall`;
      this.winPopup = window.open(
        popupLocation,
        'popup',
        'width=1000,height=700,right=10,bottom=150',
      );
      return;
      // stop listening until further notice.
    } else {
      this.ring();
      if (this.props.defaultSession.sessionCost > 0) {
        this.setState({callRequestStartedNonResponded: true});
        this.tokBoxInit();
      } else {
        this.setState({callRequestStartedNonResponded: true});
        if (mentorIsBusy) {
          // this.callingTimeOut();
          this.context.setCallState(
            VIDABOO_CONSTANTS.VIDEO_CALL_STATE.JOIN_CALL_REQUESTED,
          );
          const callRequestData = this.createCallRequestData();
          callRequestData.SubType =
            VIDABOO_CONSTANTS.CALL_SUBTYPES.REQUEST_JOIN_CALL;
          ListeningRoomService.publishToListeningRoom(
            callRequestData,
            this.props.currentUser.userId,
            this.props.mentor.mentorDto.mentorOwnerId,
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
          );
        } else {
          this.tokBoxInit();
        }
      }
    }
  };

  stopRing = () => {
    if (this.soundInterval) clearInterval(this.soundInterval);
    this.soundInterval = null;
    this.stopSound();
  };

  stopSound = () => {
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      this.setState({
        audioPaused: true,
      });
    } else {
      this.callAudio.pause();
      this.callAudio.currentTime = 0;
    }
  };
  resetCallInitiator = () => {
    this.stopRing();
    clearInterval(this.sessionHeartBeatInterVal);
    this.paymentInProcess = false;
    this.props?.widgetContext?.setCallReqId(null);
    this.props?.widgetContext?.setEngagerReqId(null);
    this.cancelListenerToWindowChangeLocation();
    this.setState({
      callRequestStartedNonResponded: false,
      popupButtons: [],
      popupFunction: [],
      peerCameraState: true,
      callRecordingActive: false,
      audioPaused: true,
      showRecordingPopup: false,
      totalStreamsCount: 0,
      maxAmountOfVideoStreamsAchieved: false,
      shouldStartPaymentFlow: false,
    });
  };
  hangUp = (sendHangUpMessageToPeer) => {
    this.props.widgetContext.setSelectedChatRoomId(
      this.props.mentor.mentorDto.mentorOwnerId,
    );
    this.props.widgetContext.setPrivateChatRoomDto(null);
    this.context.setChatMessageCueCounter(true);
    this.context.setChatMessageCue(false);
    this.resetCallInitiator();
    if (sendHangUpMessageToPeer) {
      //indication that is self initiated hangup
      this.setState({
        showNotificationPopup: true,
        notificationText:
          // STRINGS.POPUP_MESSAGES.CALL_APP_MESSAGES.SELF_CONNECTION_CLOSED,
          this.context.languageSet.VIDEO_CALL_CAT.SELF_CONNECTION_CLOSED,
        notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
        popupAcceptBtnFunc: null,
        popupAcceptBtnText: null,
        popupRejectBtnFunc: null,
        popupRejectBtnText: null,
        popupCloseBtnFunc: null,
        popupCloseBtnText: null,
      });
    } else {
      this.setState({
        showNotificationPopup: true,
        notificationText: this.context.languageSet.VIDEO_CALL_CAT.CALL_END,
        notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
        popupAcceptBtnFunc: null,
        popupAcceptBtnText: null,
        popupRejectBtnFunc: null,
        popupRejectBtnText: null,
        popupCloseBtnFunc: null,
        popupCloseBtnText: null,
      });
    }
    this.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CALL_ENDED_CLIENT,
      this.props.mentor.mentorDto.profileName,
    );
    this.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CALL_ENDED_CLIENT,
    );
    this.props?.widgetContext?.setCallReqId(null);
    this.props?.widgetContext?.setEngagerReqId(null);

    if (sendHangUpMessageToPeer) {
      const hangUpData = {
        SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.HANGUP,
      };

      ListeningRoomService.publishToListeningRoom(
        hangUpData,
        this.props.currentUser.userId,
        this.props.mentor.mentorDto.mentorOwnerId,
        VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
      );
    }
    this.clientSessionInstanceEnd();
    this.fncObj.changeIframeSize(
      VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
      'callInitiator',
    );
  };
  createCallRequestData = () => {
    // console.debug(this.props.fldObj, 'Props this.fldObj');
    const paypalOn = this.props.defaultSession.sessionCost > 0;
    return {
      SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.CALL_REQUEST,
      requesterUserId: this.props.currentUser.userId,
      // requesterProfileName: this.props.currentUser.profileName,
      OTSessionData: this.OTSessionData,
      paypalOn: paypalOn,
      payKey: this.paypalPayKey,
      engagerReqId: this.props.widgetContext?.engagerReqId,
      sessionTemplateDto: this.props.defaultSession,
      peerClientInfo: this.peerClientInfo,
      roomId: this.props.widgetContext?.chatRoomId, // todo: https://consolto.atlassian.net/browse/CFW-316
      mentorId: this.props.mentor.mentorDto.mentorId,
    };
  };
  callingTimeOut = () => {
    // console.debug('in callingTimeOut');
    clearTimeout(this.infoCollectorTimer);
    this.infoCollectorTimer = setTimeout(() => {
      this.props.postCallFailFnc();
    }, VIDABOO_CONSTANTS.CALL_TIMER.TIMER_TIMEOUT);
  };

  tokBoxInit = async (joinExistingMeetingOtSessionData) => {
    if (joinExistingMeetingOtSessionData) {
      this.OTSessionData = joinExistingMeetingOtSessionData;
    } else {
      const otSessionDataResponse = await OpenTokService.getOTSessionData();
      if (otSessionDataResponse.status !== 201) {
        console.debug('Error: failure in receiving OT Session Data');
        window.alert("Couldn't initialize video session");
        return;
      }
      this.OTSessionData = otSessionDataResponse.data;
    }
    this.otVideoFncObj.openTokConnect(this.OTSessionData);
    this.listenToWindowChangeLocation();
    if (!joinExistingMeetingOtSessionData) {
      if (this.checkMentorAvailability()) {
        const paypalOn = this.props.defaultSession.sessionCost > 0;
        if (this.paypalPayKey <= 0 && paypalOn) {
          console.error('error 102');
          // we shouldn't get here
          alert('ERROR 102');
        } else {
          const callRequestData = this.createCallRequestData();
          ListeningRoomService.publishToListeningRoom(
            callRequestData,
            this.props.currentUser.userId,
            this.props.mentor.mentorDto.mentorOwnerId,
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
          );
        }

        this.callingTimeOut();
      } else {
        //mentor is not available. Hence need to stop process.
        this.setState({callRequestStartedNonResponded: false});
        this.props.postCallFailFnc();
      }
    }
  };
  cancelListenerToWindowChangeLocation = () => {
    window.onbeforeunload = null;
  };
  listenToWindowChangeLocation = () => {
    window.onbeforeunload = (e) => {
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue =
        'You are in a call. Are you sure you want to move to another page?';
    };
  };
  sendCA = (eventAction) => {
    var mentorOnline = false;
    if (eventAction === 'startingCallMentorOnline') {
      // we use the dimensionsMap.mentorOnline instead
      eventAction = VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.CALL.START_CALL;
      mentorOnline = true;
    } else if (eventAction === 'startingCallMentorOffline') {
      eventAction = VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.CALL.START_CALL;
    }
    var error = false;
    AnalyticsService.saveConsoltoAnalyticsEvent({
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.CALL,
      action: eventAction,
      senderCreationTime: new Date().getTime(),
      userId: this.props.currentUser.userId,
      mentorId: this.props.mentor.mentorDto.mentorId,
      userRole: this.props.currentUser.role,
      error: error,
      dimensionsMap: {
        widget: utilsService.getIsInWidget(),
        peerUserId: this.props.mentor.mentorDto.mentorOwnerId,
        mentorOnline: mentorOnline,
      },
    });
  };

  sendGA = (eventAction, eventLabel) => {
    AnalyticsService.trackEvent({
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.CALL,
      action: eventAction,
      label: eventLabel,
      value: '',
      sendToParent: this.props.enableWidgetAnalyticsForward,
    });
    this.sendCA(eventAction);
  };
  dispatchConsoltoEvents = (eventAction) => {
    this.props.dispatchConsoltoEvents &&
      this.props.dispatchConsoltoEvents(eventAction);
  };
  doWhenCameraStateChange = (newState) => {
    var messageToSend = {
      SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.CAMERA_STATE,
      cameraState: newState,
    };
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.mentor.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
    );
  };
  onVideoContainerSizeChanged = (size) => {
    // console.debug(size);
    this.setState({
      isVideoContainerTiny: VIDABOO_CONSTANTS.ACTIVE_VIDEO_SIZE.TINY === size,
    });
  };
  handleCallRecordingState = (callRecordingActive) => {
    this.setState({
      showRecordingPopup: callRecordingActive,
      callRecordingActive,
    });
  };
  setTotalStreamsCount = (count) => {
    const maxAmountOfVideoStreamsAchieved =
      count >= VIDABOO_CONSTANTS.MAX_VIDEO_STREAMS_PERMITTED;
    this.setState({totalStreamsCount: count, maxAmountOfVideoStreamsAchieved});
  };

  closePaymentFlow = () => {
    this.setState({
      shouldStartPaymentFlow: false,
    });
  };

  doWhenPaymentFlowCompletedSuccessfully = (response) => {
    const status = response.status;
    const messageToSend = {
      SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.PAYMENT_STATUS,
      status: status,
      // apiKey: this.paypalPayKey,
    };
    if (
      response.status ===
      VIDABOO_CONSTANTS.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS
    ) {
      //send to client that every thing fine.
      messageToSend.status = status;
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS);
    } else {
      //send to client that somethng wrong with payment
      // console.debug('send to client that somethng wrong with payment');
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
      messageToSend.status = status;
    }
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.mentor.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
    );
    //PRService.emitMessage(messageToSend);
  };

  doWhenPaymentFailed = () => {
    //send to client that somethng wrong with payment
    const messageToSend = {
      SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.PAYMENT_STATUS,
      status: 'FAIL',
    };
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.mentor.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
    );
    this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
    // PRService.emitMessage('');
  };

  rejectPayment = () => {
    this.handleToast(
      VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
      'Payment cancelled',
    );
    this.setState({shouldStartPaymentFlow: false});
    this.hangUp();
    this.otVideoFncObj.doWhenReject();
    const messageToSend = {
      SubType: VIDABOO_CONSTANTS.CALL_SUBTYPES.PAYMENT_STATUS,
      status: 'FAIL',
    };
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.mentor.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CALL,
    );
  };

  sendPaymentRequestAcceptedStatus = () => {
    // const messageToSend = {
    //   SubType:
    //     VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_ACCEPTED,
    // };
    // this.publishToListeningRoom(
    //   messageToSend,
    //   VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
    // );
  };
  handleToast = (toastType, toastTitle) => {
    const tempToastText = toastTitle
      ? toastTitle
      : toastType === VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS
        ? 'Payment success'
        : 'Payment failed';
    const toastObj = utilsService.getToastObj({
      toastTitle: tempToastText,
      toastType,
    });
    this.context.addToastObj(toastObj);
  };

  render() {
    return (
      <div
        className={` ${
          this.context.callState !== VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT
            ? this.state.isVideoContainerTiny
              ? ' et-video-small-client et-videocall-active '
              : `et-call-initiator-container ${
                  utilsService.getIsClient() ? 'et-video-normal-client' : ''
                } et-videocall-active `
            : 'et-call-initiator-container-no-width'
        }  `}>
        {/* {this.props.mentorStatus} */}
        {this.state.showNotificationPopup && (
          <NotificationComponent
            notificationType={this.state.notificationType}
            notificationTxt={this.state.notificationText}
            acceptBtnTxt={this.state.popupAcceptBtnText}
            acceptBtnFunc={this.state.popupAcceptBtnFunc}
            rejectBtnTxt={this.state.popupRejectBtnText}
            rejectBtnFunc={this.state.popupRejectBtnFunc}
            closeBtnTxt={this.state.popupCloseBtnText}
            closeBtnFunc={
              this.state.popupCloseBtnFunc
                ? this.state.popupCloseBtnFunc
                : this.closePopups
            }
          />
        )}
        {this.state.showRecordingPopup && (
          <NotificationComponent
            closeBtnTxt={'OK'}
            closeBtnFunc={() => {
              this.setState({
                showRecordingPopup: false,
              });
            }}
            notificationTxt={
              this.context.languageSet.VIDEO_CALL_CAT.CALL_BEING_RECORDED
            }
          />
        )}
        {this.state.shouldStartPaymentFlow && this.props.defaultSession && (
          <Suspense fallback={<SuspenseLoader />}>
            <C2cPaymentComponent
              shouldStartPaymentFlow={this.state.shouldStartPaymentFlow}
              currentUser={this.props.currentUser}
              mentorDto={this.props.mentor.mentorDto}
              sessionTemplateDto={this.props.defaultSession}
              chatRoomId={this.props.widgetContext?.chatRoomId}
              paymentFlowType={
                VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
                  .PRE_CALL
              }
              closePaymentFlow={this.closePaymentFlow}
              doWhenPaymentFailed={this.doWhenPaymentFailed}
              doWhenPaymentFlowCompletedSuccessfully={
                this.doWhenPaymentFlowCompletedSuccessfully
              }
              rejectPayment={this.rejectPayment}
              sendPaymentRequestAcceptedStatus={
                this.sendPaymentRequestAcceptedStatus
              }
            />
          </Suspense>
        )}

        {this.otVideoFncObj && (
          <Suspense fallback={<></>}>
            <OtVideo
              otVideoMode={VIDABOO_CONSTANTS.OT_VIDEO_MODE.CALL_INITIATOR}
              doWhenStreamCreated={this.doWhenStreamCreated}
              fncObj={this.otVideoFncObj}
              fldObj={this.fldObjToOtVideo}
              selectedWidgetAppType={this.props.selectedWidgetAppType}
              sessionInstanceEnd={this.clientSessionInstanceEnd}
              changeIframeSize={this.fncObj.changeIframeSize}
              hangUp={this.hangUp}
              sessionMode={this.props.defaultSession.sessionMode}
              doWhenCameraStateChange={this.doWhenCameraStateChange}
              peerCameraState={this.state.peerCameraState}
              onVideoContainerSizeChanged={this.onVideoContainerSizeChanged}
              callRecordingActive={this.state.callRecordingActive}
              setTotalStreamsCount={this.setTotalStreamsCount}
              totalStreamsCount={this.state.totalStreamsCount}
              maxAmountOfVideoStreamsAchieved={
                this.state.maxAmountOfVideoStreamsAchieved
              }
              isCameraPermissionGranted={
                this.props.permissionsStatusesObj[
                  VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA
                ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
              }
              isMicrophonePermissionGranted={
                this.props.permissionsStatusesObj[
                  VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
                ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
              }
              setShowPermissionsPopup={this.props.setShowPermissionsPopup}
              doWhenChatIconOrChatMsgNotificationClickedInCall={
                this.props.doWhenChatIconOrChatMsgNotificationClickedInCall
              }
            />
          </Suspense>
        )}
      </div>
    );
  }
}
CallInitiator.contextType = AppContext;

export default withWidgetContext(CallInitiator);
